import Vue from 'vue'
import VPopover from 'vue-js-popover'
import router from '@router'
import store from '@state/store'
import axios from 'axios'
import VueGtag from 'vue-gtag'
import App from './app.vue'

// Globally register all `_base`-prefixed components
import '@components/_globals'

Vue.use(VPopover, { tooltip: true })
Vue.use(VueGtag, {
  config: { id: 'G-6MFT9S93YB' },
})

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
